module.exports = __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo-3-b3a74487f18abab0f85b0b564fb12989.png";